<template>
  <Card :id="careType" :clickable="true" class="care-type-card-item" @click="handleSelect">
    <div class="card-type-card-content">
      <component :is="careTypeDetails[careType].icon" class="mb-8" />
      <span class="mb-8">{{ careTypeDetails[careType].title }}</span>
      <Spinner v-if="selected" />
      <Arrow v-else-if="showArrow" />
    </div>
  </Card>
</template>

<script lang="ts">
import Card from '../card/Card.vue';
import Arrow from '../../icons/Arrow.vue';
import Spinner from '../spinner/Spinner.vue';

import { markComponentRaw } from '@/helpers/markComponentRaw';
import ChildCareIcon from '../../icons/BabysitterIcon.vue';
import NannyIcon from '../../icons/NannyIcon.vue';
import HousekeepingIcon from '../../icons/HousekeepingIcon.vue';
import PetCareIcon from '../../icons/DashboardPetCareIcon.vue';
import CompanionCareIcon from '../../icons/CompanionCareIcon.vue';
import SpecialNeedsCareIcon from '../../icons/SpecialNeedsCareIcon.vue';

const CARE_TYPE_DETAILS = {
  CHILD_CARE: {
    icon: markComponentRaw(ChildCareIcon),
    title: 'Child Care',
  },
  BABYSITTER: {
    icon: markComponentRaw(ChildCareIcon),
    title: 'Babysitter',
  },
  NANNY: {
    icon: markComponentRaw(NannyIcon),
    title: 'Nanny',
  },
  HOUSEKEEPING: {
    icon: markComponentRaw(HousekeepingIcon),
    title: 'Housekeeping',
  },
  PET_CARE: {
    icon: markComponentRaw(PetCareIcon),
    title: 'Pet care',
  },
  SPECIAL_NEEDS: {
    icon: markComponentRaw(SpecialNeedsCareIcon),
    title: 'Special needs care',
  },
  COMPANION_CARE: {
    icon: markComponentRaw(CompanionCareIcon),
    title: 'Companion care',
  },
};

export default {
  name: 'PoppinsCareTypeCard',
  components: {
    Card,
    Arrow,
    Spinner,
  },
  props: {
    selected: {
      type: Boolean,
      default: false,
    },
    careType: {
      type: String,
      required: true,
    },
    showArrow: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    careTypeDetails() {
      return CARE_TYPE_DETAILS;
    },
  },
  methods: {
    handleSelect() {
      this.$emit('select', this.careType);
    },
  },
};
</script>

<style lang="scss" scoped>
.care-type-card-item {
  // Dynamic clickable hover behavior controlled by CSS custom property
  // When --dynamic-clickable-hover is set, apply full-width and interactive styling
  // See profile page for visibility of this custom property
  @supports (--dynamic-clickable-hover: 1) {
    --dynamic-clickable-hover: var(--dynamic-clickable-hover);
  }

  &:is([style*='--dynamic-clickable-hover']) {
    margin: 0 !important;
    width: 100% !important;
    max-width: none !important;
    transition:
      box-shadow 250ms ease-out,
      transform 100ms ease-out;

    &:hover {
      box-shadow: 0 2px 10px 0 rgba(5, 7, 15, 0.24);
      transform: translateY(-1px);
      cursor: pointer;
    }

    svg {
      width: 48px !important;
      height: 48px !important;
    }

    span {
      font-size: 14px !important;
      line-height: 1.4 !important;
    }

    .card-type-card-content {
      padding: 24px 16px !important;
      height: auto !important;
      min-height: 140px !important;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      gap: 8px;
    }
  }

  .card-type-card-content {
    align-items: center;
    background: #fff;
    padding: 1.5rem 0.5rem 1rem 0.5rem;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
    text-align: center;
    height: 152px;
    width: 100%;
  }
}
</style>
